

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

require('components/xo-ui-components/src/modal/directive');

require('components/xo-return-to-merchant/dist/util');

var _index = require('components/xo-device-info/dist/index');

require('components/xo-form-components/src/language-options/directive');

require('components/xo-models/src/user/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _opinionlab = require('components/xo-page-components/src/footer/opinionlab');

var _opinionlab2 = _interopRequireDefault(_opinionlab);

var _footerMap = require('components/xo-page-components/src/footer/footerMap');

var _footerMap2 = _interopRequireDefault(_footerMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoShoppingCartFooter', {
    tag: 'xo-shopping-cart-footer',
    template: _template2['default'],

    props: {
        languageSwitch: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {}
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            this.year = new Date().getFullYear();
            this.isApac = function () {
                return _squid.$config.apacCountries && _squid.$config.apacCountries.indexOf(this.locale.country) > -1;
            };
            // Determine if country belongs to a region to serve correct footer links
            var getRegion = function getRegion(country) {
                var regions = _squid.$config.regions;
                for (var region in regions) {
                    if (regions[region].indexOf(country) > -1) {
                        return region;
                    }
                }

                return false;
            };
            this.footerLinks = function () {
                if (this.isApac()) {
                    return _footerMap2['default'].APAC;
                }

                return _footerMap2['default'][this.locale.country] || _footerMap2['default'][getRegion(this.locale.country)] || _footerMap2['default'].DEFAULT;
            };

            this.showPolicyInfo = function () {
                return this.isApac() || this.locale.country === 'AU';
            };

            var cancelShowModal = _angular.$rootScope.$on('showModal', function (event, config) {
                this.popupUrl = config && config.popupUrl;
                this.show = true;
                this.$digest(); // eslint-disable-line angular/ng_no_digest
            });

            this.$on('$destroy', cancelShowModal);

            this.showOL = function showOL(event) {
                event.preventDefault();

                var placeholder = 'main:ec:hermes';
                var page = _uiRouter.$state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);

                var data = {
                    opVars: {
                        rlogId: _angular.$window.meta.rlogId || '',
                        page: page || window.location.hash,
                        csci: 'Unknown',
                        calc: _angular.$window.meta.correlationId,
                        custId: 'Unknown',
                        merchantId: 'Unknown',
                        token: this.token || 'Unknown'
                    },
                    locale: {
                        country: _squid.$locale.country,
                        languageCode: _squid.$locale.lang + '_' + _squid.$locale.country
                    }
                };

                (0, _opinionlab2['default'])(data);
            };

            this.showFeedback = function () {
                if (_index.$DeviceInfo.isDevice()) {
                    return false;
                }
                return true;
            };
        }
    }
});


_angular.$rootScope;

_angular.$window;

_squid.$Component;

_squid.$locale;

_squid.$config;

_uiRouter.$state;

_index.$DeviceInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/shopping-cart-footer/directive.js
// module id = ./components/xo-page-components/src/shopping-cart-footer/directive.js
// module chunks = 1